var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wiz-progress-bar"},_vm._l((_vm.progress.max),function(num){return _c('div',{key:num,staticClass:"step",class:{
          complete: (num - 1) < _vm.progress.value,
          active: (num - 1) === _vm.progress.value,
      }})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }